import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Header from '../components/Header';
import SimpleFooter from '../components/SimpleFooter';
import ChatFAB from '../components/ChatFAB';
import Loader from '../components/Loader';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const Destinations = () => {
  const [destinations, setDestinations] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch(`${API_URL}/api/destinations`)
      .then(res => res.json())
      .then(data => {
        setDestinations(data);
        setLoading(false);
      })
      .catch(err => {
        console.error('Error fetching destinations:', err);
        setLoading(false);
      });
  }, []);

  const getSlug = (name) => {
    return name.toLowerCase().replace(/\s+/g, '-');
  };

  if (loading) {
    return (
      <>
        <Header />
        <Loader fullPage={true} />
        <SimpleFooter />
      </>
    );
  }

  return (
    <>
      <Header />
      <div className="destinations-page">
        <div className="destinations-hero">
          <div className="destinations-hero-content">
            <h1 data-text="Explore Our Destinations">Explore Our Destinations</h1>
            <p>Discover amazing places around the world with our curated travel packages</p>
          </div>
        </div>

        <div className="destinations-container">
          <div className="destinations-grid">
            {destinations.map(destination => (
              <Link
                key={destination.id}
                to={`/destinations/${getSlug(destination.name)}`}
                className="destination-card-link"
              >
                <div className="destination-card-page">
                  <div className="destination-image-wrapper">
                    <img 
                      src={destination.image} 
                      alt={destination.name}
                      className="destination-image"
                    />
                    <div className="destination-overlay-gradient"></div>
                  </div>
                  <div className="destination-card-content">
                    <h3 className="destination-name">{destination.name}</h3>
                    <p className="destination-tagline">{destination.description}</p>
                    <div className="destination-meta">
                      <span className="destination-country">
                        <i className="fa-solid fa-location-dot"></i> {destination.country}
                      </span>
                      <span className="destination-cta">View Details</span>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>

          {destinations.length === 0 && (
            <div className="no-destinations">
              <p>No destinations available at the moment.</p>
            </div>
          )}
        </div>
      </div>
      <SimpleFooter />
      <ChatFAB />
    </>
  );
};

export default Destinations;
